module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-item-audio"
  }, [(_vm.data.previewImageUrl) ? _c('div', {
    staticClass: "image-wrapper"
  }, [_c('a', {
    attrs: {
      "href": ("https://www.develteam.com/userdata/media/" + (_vm.data.mediaUrl)),
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": ("https://www.develteam.com/userdata/media/" + (_vm.data.previewImageUrl)),
      "alt": _vm.data.title + ' preview image',
      "title": _vm.data.title + ' preview image'
    }
  })])]) : _vm._e(), _vm._v(" "), _c('audio', {
    attrs: {
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": ("https://www.develteam.com/userdata/media/" + (_vm.data.mediaUrl)),
      "type": "audio/mpeg"
    }
  }), _vm._v("\n        Your browser does not support the video tag.\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-04bcc356!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Common/MediaItems/MediaItemAudio.vue
// module id = 816
// module chunks = 2